import {api} from "./api";
import axios from "axios";
import firebase from 'firebase/compat/app'
import "firebase/compat/storage";

export const addZero = (str) => {
    return ('0' + str).substr(-2)
}
export const dateAndTimeInputFormat = date => {
    return date.getFullYear() +
        '-' + addZero(date.getMonth() + 1) +
        '-' + addZero(date.getDate()) +
        'T' + addZero(date.getHours()) +
        ':' + addZero(date.getMinutes());
}
export const addMinutes = (date, minutes) => {
    return new Date(date.getTime() + minutes * 60000);
}
export const convertToNumber = dateStr => {
    const [hour, minute] = dateStr.split(':')
    return Number(hour) + (Number(minute) / 60)
}

export const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/')
    ;
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export const registerPushSW = () => {
    if (process?.env?.NODE_ENV === 'development') {
        return Promise.reject()
    }
    return navigator.serviceWorker.ready.then(function (registration) {
        return registration.pushManager.getSubscription()
            .then(async function (subscription) {
                if (subscription) {
                    return subscription;
                }
                const vapidPublicKey = (await axios.get(api + '/push-notifications')).data;
                const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);
                return registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: convertedVapidKey
                });
            });
    })
}

export const uploadToGCP = async (file, uuid) => {
    return new Promise((res,rej)=>{

    const storageRef = firebase.storage().ref().child(`userImages/${uuid}/${file.name}`);

    const uploadTask = storageRef.put(file);


     uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        function (snapshot) {
        }, function (error) {
             rej()
        }, function () {
            return uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                res({url: downloadURL, name: file.name})
            });
        });
    })
}

export const deleteFromGCP = async (filename, uuid) => {
    const desertRef = firebase.storage().ref().child(`userImages/${uuid}/${filename}`);

    return desertRef.delete().then(function () {
        return true;
    }).catch(function (error) {
        throw new Error()

    });
}

export const downloadFromGcp = async (file, uuid) => {
    const desertRef = firebase.storage().ref(`userImages/${uuid}/${file.name}`);

    return desertRef.delete().then(function () {
        return true;
    }).catch(function (error) {
        throw new Error()

    });
}